import { LoanType } from '../loans/LoanType';

export enum DrawBudgetLineCategory {
    LandPurchase = 1,
    SiteWork = 2,
    Foundation = 3,
    Framing = 4,
    ExteriorFinishes = 5,
    MajorSystemRoughIns = 6,
    InteriorFinishes = 7,
    FinalSteps = 8,
    Other = 9,
    Setup = 10,
    Utilities = 11,
}

export const DrawBudgetLineCategories = [
    {
        id: DrawBudgetLineCategory.LandPurchase,
        loanTypes: [
            LoanType.Construction,
            LoanType.SubNoteConstruction,
            LoanType.Land,
            LoanType.FixFlip,
            LoanType.SubNoteFixFlip,
            LoanType.BuildRent,
            LoanType.Model,
        ],
        loanTypeMetadata: [
            { type: LoanType.Construction, description: 'Land Cost', sortOrder: 0 },
            { type: LoanType.SubNoteConstruction, description: 'Land Cost', sortOrder: 0 },
            { type: LoanType.Land, description: 'Land Cost', sortOrder: 0 },
            { type: LoanType.FixFlip, description: 'Property Cost', sortOrder: 0 },
            { type: LoanType.SubNoteFixFlip, description: 'Property Cost', sortOrder: 0 },
            { type: LoanType.BuildRent, description: 'Land Cost', sortOrder: 0 },
            { type: LoanType.Model, description: 'Land Cost', sortOrder: 0 },
        ],
    },
    {
        id: DrawBudgetLineCategory.SiteWork,
        loanTypes: [
            LoanType.Construction,
            LoanType.SubNoteConstruction,
            LoanType.Land,
            LoanType.FixFlip,
            LoanType.SubNoteFixFlip,
            LoanType.BuildRent,
            LoanType.Model,
        ],
        loanTypeMetadata: [
            { type: LoanType.Construction, description: 'Site Work', sortOrder: 1 },
            { type: LoanType.SubNoteConstruction, description: 'Site Work', sortOrder: 1 },
            { type: LoanType.Land, description: 'Site Work', sortOrder: 3 },
            { type: LoanType.FixFlip, description: 'Site Work', sortOrder: 1 },
            { type: LoanType.SubNoteFixFlip, description: 'Site Work', sortOrder: 1 },
            { type: LoanType.BuildRent, description: 'Site Work', sortOrder: 1 },
            { type: LoanType.Model, description: 'Site Work', sortOrder: 1 },
        ],
    },
    {
        id: DrawBudgetLineCategory.Foundation,
        loanTypes: [LoanType.Construction, LoanType.SubNoteConstruction, LoanType.BuildRent, LoanType.Model],
        loanTypeMetadata: [
            { type: LoanType.Construction, description: 'Foundation', sortOrder: 2 },
            { type: LoanType.SubNoteConstruction, description: 'Foundation', sortOrder: 2 },
            { type: LoanType.BuildRent, description: 'Foundation', sortOrder: 2 },
            { type: LoanType.Model, description: 'Foundation', sortOrder: 2 },
        ],
    },
    {
        id: DrawBudgetLineCategory.Framing,
        loanTypes: [LoanType.Construction, LoanType.SubNoteConstruction, LoanType.BuildRent, LoanType.Model],
        loanTypeMetadata: [
            { type: LoanType.Construction, description: 'Framing', sortOrder: 3 },
            { type: LoanType.SubNoteConstruction, description: 'Framing', sortOrder: 3 },
            { type: LoanType.BuildRent, description: 'Framing', sortOrder: 3 },
            { type: LoanType.Model, description: 'Framing', sortOrder: 3 },
        ],
    },
    {
        id: DrawBudgetLineCategory.ExteriorFinishes,
        loanTypes: [
            LoanType.Construction,
            LoanType.SubNoteConstruction,
            LoanType.FixFlip,
            LoanType.SubNoteFixFlip,
            LoanType.BuildRent,
            LoanType.Model,
        ],
        loanTypeMetadata: [
            { type: LoanType.Construction, description: 'Exterior Finishes', sortOrder: 4 },
            { type: LoanType.SubNoteConstruction, description: 'Exterior Finishes', sortOrder: 4 },
            { type: LoanType.FixFlip, description: 'Exterior Structure', sortOrder: 2 },
            { type: LoanType.SubNoteFixFlip, description: 'Exterior Structure', sortOrder: 2 },
            { type: LoanType.BuildRent, description: 'Exterior Finishes', sortOrder: 4 },
            { type: LoanType.Model, description: 'Exterior Finishes', sortOrder: 4 },
        ],
    },
    {
        id: DrawBudgetLineCategory.MajorSystemRoughIns,
        loanTypes: [
            LoanType.Construction,
            LoanType.SubNoteConstruction,
            LoanType.FixFlip,
            LoanType.SubNoteFixFlip,
            LoanType.BuildRent,
            LoanType.Model,
        ],
        loanTypeMetadata: [
            { type: LoanType.Construction, description: 'Major System Rough-ins', sortOrder: 5 },
            { type: LoanType.SubNoteConstruction, description: 'Major System Rough-ins', sortOrder: 5 },
            { type: LoanType.FixFlip, description: 'Major Systems', sortOrder: 3 },
            { type: LoanType.SubNoteFixFlip, description: 'Major Systems', sortOrder: 3 },
            { type: LoanType.BuildRent, description: 'Major System Rough-ins', sortOrder: 5 },
            { type: LoanType.Model, description: 'Major System Rough-ins', sortOrder: 5 },
        ],
    },
    {
        id: DrawBudgetLineCategory.InteriorFinishes,
        loanTypes: [
            LoanType.Construction,
            LoanType.SubNoteConstruction,
            LoanType.FixFlip,
            LoanType.SubNoteFixFlip,
            LoanType.BuildRent,
            LoanType.Model,
        ],
        loanTypeMetadata: [
            { type: LoanType.Construction, description: 'Interior Finishes', sortOrder: 6 },
            { type: LoanType.SubNoteConstruction, description: 'Interior Finishes', sortOrder: 6 },
            { type: LoanType.FixFlip, description: 'Interior', sortOrder: 4 },
            { type: LoanType.SubNoteFixFlip, description: 'Interior', sortOrder: 4 },
            { type: LoanType.BuildRent, description: 'Interior Finishes', sortOrder: 6 },
            { type: LoanType.Model, description: 'Interior Finishes', sortOrder: 6 },
        ],
    },
    {
        id: DrawBudgetLineCategory.FinalSteps,
        loanTypes: [
            LoanType.Construction,
            LoanType.SubNoteConstruction,
            LoanType.FixFlip,
            LoanType.SubNoteFixFlip,
            LoanType.BuildRent,
            LoanType.Model,
        ],
        loanTypeMetadata: [
            { type: LoanType.Construction, description: 'Final Steps', sortOrder: 7 },
            { type: LoanType.SubNoteConstruction, description: 'Final Steps', sortOrder: 7 },
            { type: LoanType.FixFlip, description: 'Final Structure', sortOrder: 6 },
            { type: LoanType.SubNoteFixFlip, description: 'Final Structure', sortOrder: 6 },
            { type: LoanType.BuildRent, description: 'Final Steps', sortOrder: 7 },
            { type: LoanType.Model, description: 'Final Steps', sortOrder: 7 },
        ],
    },
    {
        id: DrawBudgetLineCategory.Other,
        loanTypes: [LoanType.FixFlip, LoanType.SubNoteFixFlip],
        loanTypeMetadata: [
            { type: LoanType.FixFlip, description: 'Expand Primary Structure', sortOrder: 5 },
            { type: LoanType.SubNoteFixFlip, description: 'Expand Primary Structure', sortOrder: 5 },
        ],
    },
    {
        id: DrawBudgetLineCategory.Setup,
        loanTypes: [LoanType.Land],
        loanTypeMetadata: [{ type: LoanType.Land, description: 'Setup', sortOrder: 1 }],
    },
    {
        id: DrawBudgetLineCategory.Utilities,
        loanTypes: [LoanType.Land],
        loanTypeMetadata: [{ type: LoanType.Land, description: 'Utilities', sortOrder: 2 }],
    },
];
